import cn from "@/utils/mergeClassNames";
import { useMemo } from "react";

type Props = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const LoadingSpinner = ({ className, ...props }: Props) => {
  const borderWidth = useMemo(() => {
    if (className?.includes("size-")) {
      const size = className?.split("size-")[1].split(" ")[0];
      if (Number(size) > 14) {
        return "border-5";
      } else if (Number(size) > 10) {
        return "border-4";
      } else if (Number(size) > 6) {
        return "border-3";
      }
    }

    return "border-2";
  }, [className]);

  return (
    <span
      className={cn(
        "size-4 animate-spin rounded-full border-solid border-current border-t-transparent border-r-transparent",
        borderWidth,
        className,
      )}
      {...props}
    />
  );
};

export default LoadingSpinner;
